import React, {useEffect, useState} from 'react'
import {createSearchParams, Link, useNavigate, useSearchParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import BottomButton from "@/view/common/component/button/BottomButton";
import Input from "@/view/common/component/Input";
import Icon from "@/view/common/component/Icon";
import UserService, {SvcUser, SvcUserDataRes} from "@/service/UserService";
import StorageUtil from "@/common/StorageUtil";
import {ACCESS_TOKEN, USER_ID, USER_NAME, TEAM_ID, TEAM_NAME} from "@/common/Constant";
import StringUtil from "@/common/StringUtil";
import Toast from "@/view/common/popup/Toast";
import ValidateUtil from "@/common/ValidateUtil";

const EmailLogin = () => {
    const navigate = useNavigate()
    const defaultTheme = 'dark'
    const messageList = {
        'email': {'label':'이메일', 'name':'email', 'title': 'Football Position', 'subTitle': '가입할 때 사용한 이메일을 입력해 주세요'},
        'pwd': {'label':'비밀번호', 'name':'pwd', 'title': 'Football Position', 'subTitle': '영문, 숫자 포함 10자 이상이에요'},
    }
    const [isOpen2, setIsOpen2] = useState(false)
    const [isOpen3, setIsOpen3] = useState(false)
    const [isOpen4, setIsOpen4] = useState(false)
    const [message,setMessage] = useState(messageList.email)

    const [searchParam] = useSearchParams()
    const searchParamEmail = searchParam.get("email")
    const [email, setEmail] = useState({value: searchParamEmail !== null ? searchParamEmail :'', errMsg: ''})
    const [pwd, setPwd] = useState({value:'', errMsg: ''})
    const [disable, setDisable] = useState(true)
    const [typePassword, setTypePassword] = useState('password')

    const {refetch: emailSignIn} = useQuery<SvcUser, AxiosError>(
        ['emailSignIn'],
        ()=> UserService.emailSignIn(email.value, pwd.value),
        {
            onSuccess: (data: SvcUser) => {
                signInSuccess(data)
            }
        }
    )

    const clickLogin = async() => {
        await emailSignIn()
    }

    const signInSuccess =  (data: SvcUser) => {
        if(StringUtil.isNotEmpty(String(data.data))){
            switch (data.data.status){
                case '정상':
                    StorageUtil.setLocalStorage(ACCESS_TOKEN, data.data.token)
                    StorageUtil.setLocalStorage(USER_ID, data.data.userId.toString())
                    StorageUtil.setLocalStorage(TEAM_ID, data.data.teamId.toString())
                    StorageUtil.setLocalStorage(TEAM_NAME, data.data.teamName.toString())
                    StorageUtil.setLocalStorage(USER_NAME, data.data.nickName.toString())
                    navigate('/')
                    break
                case '신청':
                    setIsOpen3(true)
                    break
                case '탈퇴':
                    setIsOpen4(true)
                    break
            }
        }else{
            setIsOpen2(true)
        }
    }

    const validateEmail = (value:string) =>{
        const result = ValidateUtil.checkValidEmail(value)
        setEmail({value: result.value, errMsg: result.errMsg})
    }

    const validatePwd = (value:string) =>{
        const result = ValidateUtil.checkValidPwd(value)
        setPwd({value: result.value, errMsg: result.errMsg})
    }

    const clickLook = () => {
        if(typePassword === 'text'){
            setTypePassword('password')
        }else{
            setTypePassword('text')
        }
    }

    useEffect(()=> {
        if(StringUtil.isEmpty(email.value) || StringUtil.isEmpty(pwd.value)){
            setDisable(true)
        }else if(StringUtil.isNotEmpty(email.errMsg) || StringUtil.isNotEmpty(pwd.errMsg)){
            setDisable(true)
        }else{
            setDisable(false)
        }
    }, [email, pwd])

    return (
        <>
            <div id='NoSignUpEmail' className={'bg-cl-black'}>
                <div className={'main-content'}>
                    <div className={'h5_m title mt-39px'}>{message.title}</div>
                    <div className={'b2_r title mt-16px ft-cl-hint'}>{message.subTitle}</div>
                    <div className={'input-wrapper'}>
                        <div className={'b1_r input-item'}>
                            <Input theme={defaultTheme}
                                   label={messageList.email.label}
                                   name={messageList.email.name}
                                   value={email.value}
                                   rightContent={<div className={'click-area'} onClick={() => setEmail({value: '', errMsg: ''})}><Icon iconClass={'input-delete-d h-17px'}/></div>}
                                   onChange={(ev) => setEmail(prevState => ({value: ev.target.value, errMsg: prevState.errMsg}))}
                                   required={true}
                                   onBlur={() => validateEmail(email.value)}
                                   onKeyUp={() => validateEmail(email.value)}
                                   onClick={() => setMessage(messageList.email)}
                                   errorMsg={email.errMsg}
                            >
                                {email.value}
                            </Input>
                        </div>
                        <div className={'b1_r input-item'}>
                            <Input theme={defaultTheme}
                                   label={messageList.pwd.label}
                                   name={messageList.pwd.name}
                                   value={pwd.value}
                                   rightContent={<div className={'click-area'} onClick={() => clickLook()}><Icon iconClass={'ic-look h-17px'}/></div>}
                                   onChange={(ev) => setPwd(prevState => ({value: ev.target.value, errMsg: prevState.errMsg}))}
                                   required={true}
                                   onBlur={() => validatePwd(pwd.value)}
                                   onKeyUp={() => validatePwd(pwd.value)}
                                   onClick={() => setMessage(messageList.pwd)}
                                   errorMsg={pwd.errMsg}
                                   type={typePassword}
                            >
                                {pwd.value}
                            </Input>
                        </div>
                    </div>
                    <div className={'signup-wrapper text-center'}>
                        <span className={'c1_r signup-item ft-cl-caption'}>계정이 없으신가요?</span>
                        <span className={'c1_r signup-item text-underline'}><Link to={"/signup"}>이메일 회원가입</Link></span>
                    </div>
                </div>
                {
                    !disable ?
                        <BottomButton title={'다음'} disabled={false} onClick={() => clickLogin()} />
                        :
                        <BottomButton title={'다음'} disabled={true}  />
                }

            </div>
            <Toast content={<div style={{lineHeight:'1.5'}}>회원정보와 일치하지 않아요.<br/>이메일과 비밀번호를 확인해주세요.</div>}  isOpen={isOpen2} onClose={ () => setIsOpen2(false) }></Toast>
            <Toast content={<div style={{lineHeight:'1.5'}}>회원가입 신청 후<br/> 관리자의 승인을 기다리고 있습니다.</div>}  isOpen={isOpen3} onClose={ () => setIsOpen3(false) }></Toast>
            <Toast content={<div style={{lineHeight:'1.5'}}>탈퇴한 계정 입니다.<br/>관리자에게 문의 하세요.</div>}  isOpen={isOpen4} onClose={ () => setIsOpen4(false) }></Toast>
        </>
    )
}

export default EmailLogin